export default function(element) {
  var self = this;
  self.$el = $(element);
  self.$quick_search_input = $('#quick_search_input');
  self.focused = ko.observable(false);

  self.focused.subscribe(function(newVal) {
    Kadenze.LeftNav.desktopExpand();
  });

  self.initUI = function() {
    self.initTypeahead(self.$quick_search_input, 'name');
  };

  self.initStudentSearchEngine = function(type) {
    var instructorSearch = new Bloodhound({
      datumTokenizer: Bloodhound.tokenizers.obj.whitespace(type),
      queryTokenizer: Bloodhound.tokenizers.whitespace,
      limit: 5,
      remote: {
        url: Kadenze.Routes.list_admin_users_path({ q: '%QUERY', role: 'student', type }),
        filter: function(students) {
          return $.map(students, function(student) { return { name: student.full_name, url: Kadenze.Routes.edit_admin_user_path(student.slug || student.id) }; });
        },
        ajax: {
          dataType: 'json',
          contentType: 'application/json',
          beforeSend: function() {
            //TODO: Show progress indicator
          },
          complete: function() {
            //TODO: Hide progress indicator
          }
        }
      }
    });

    instructorSearch.initialize();

    return instructorSearch;
  };

  self.initInstructorSearchEngine = function(type) {
    var instructorSearch = new Bloodhound({
      datumTokenizer: Bloodhound.tokenizers.obj.whitespace(type),
      queryTokenizer: Bloodhound.tokenizers.whitespace,
      limit: 5,
      remote: {
        url: Kadenze.Routes.list_admin_users_path({ q: '%QUERY', role: 'instructor', type }),
        filter: function(instructors) {
          return $.map(instructors, function(instructor) { return { name: instructor.full_name, url: Kadenze.Routes.edit_admin_user_path(instructor.slug || instructor.id) }; });
        },
        ajax: {
          dataType: 'json',
          contentType: 'application/json',
          beforeSend: function() {
            //TODO: Show progress indicator
          },
          complete: function() {
            //TODO: Hide progress indicator
          }
        }
      }
    });

    instructorSearch.initialize();

    return instructorSearch;
  };

  self.initCourseSearchEngine = function(type) {
    var instructorSearch = new Bloodhound({
      datumTokenizer: Bloodhound.tokenizers.obj.whitespace(type),
      queryTokenizer: Bloodhound.tokenizers.whitespace,
      limit: 5,
      remote: {
        url: Kadenze.Routes.list_admin_courses_path({ q: '%QUERY', type }),
        filter: function(courses) {
          return $.map(courses, function(course) { return { name: course.full_name, url: Kadenze.Routes.edit_course_path(course.slug || course.id) }; });
        },
        ajax: {
          dataType: 'json',
          contentType: 'application/json',
          beforeSend: function() {
            //TODO: Show progress indicator
          },
          complete: function() {
            //TODO: Hide progress indicator
          }
        }
      }
    });

    instructorSearch.initialize();

    return instructorSearch;
  };

  self.initTypeahead = function($element) {
    var studentSearchEngine = self.initStudentSearchEngine('name');
    var instructorSearchEngine = self.initInstructorSearchEngine('name');
    var courseSearchEngine = self.initCourseSearchEngine('name');

    $element.typeahead({
      hint: false,
      highlight: true,
      minLength: 1
    },
    {
      name: 'students',
      displayKey: 'name',
      source: studentSearchEngine.ttAdapter(),
      templates: {
        header: '<div class="result-group bold text-center">Students</div>'
      }
    },
    {
      name: 'instructors',
      displayKey: 'name',
      source: instructorSearchEngine.ttAdapter(),
      templates: {
        header: '<div class="result-group bold text-center">Instructors</div>'
      }
    },
    {
      name: 'courses',
      displayKey: 'name',
      source: courseSearchEngine.ttAdapter(),
      templates: {
        header: '<div class="result-group bold text-center">Courses</div>'
      }
    });

    $element.on('typeahead:selected', self.resourceSelected);
  };

  self.resourceSelected = function(obj, datum) {
    Kadenze.Request.pjax({
      url: datum.url,
      container: $('#main-pjax-container')
    });
    location.reload();
  };

  const __construct = function(that) {
    self.initUI();
    console.log('constructor called for AdminQuickFinderViewModel');
  }(this);

}
